import { FormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';

export interface CmsPersonalDetailsFieldset extends FormFieldset {
  addressFieldset: FormOverrideAddressFieldset;
  emailAddressField: FormField;
  firstNameField: FormField;
  lastNameField: FormField;
  privacyPolicyField: FormField;
  telephoneNumberField: FormField;
}
